import React, { useState, useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import LoadingSpinner from "../../components/loading-spinner";
import sleep from "../../testdata/sleep";
import useTestApplicationStatusStore from "../../testdata/changeapplicationstatus/testapplicationstatusstore";
import { YYYYDashMMDashDD_To_MMSlashDDSlashYYYY as formatDate } from "../../utilities/date-formatter";
import DotLoader from "../../components/dotloader";
import { useOutletContext } from "react-router-dom";
import { useGetApplicationHistory } from "../../new/query";

const ClientApplicationHistory = ({ applicationId }) => {
    const {ApplicationID} = useOutletContext();
    
    const {
        fetchHistory
    } = useTestApplicationStatusStore(state => {
        return {
            fetchHistory: state.actions.fetchHistory,
        };
    });

    const {data,isLoading} = useGetApplicationHistory(ApplicationID);


    const [history, setHistory] = useState([]);
    // const [showVoid, setShowVoid] = useState(false);
    const [refresh, setRefresh] = useState(true);
    const [processingFetchHistory, setProcessingFetchHistory] = useState(false);
    const [processingVoid, setProcessingVoid] = useState(-1);

    useEffect(() => {
        if (refresh) {
            _getHistory();
            setRefresh(false);
            // console.log(history)
        }
    }, [refresh]);


    const _getHistory = async () => {

        setProcessingFetchHistory(true);
        const data = fetchHistory(applicationId);
        console.log(data);
        await sleep(2000);
        setHistory([...data]);
        setProcessingFetchHistory(false);
    };
    // const _filterHistory = (historyArray) => {

    //     let filtered = [...historyArray];

    //     if (!showVoid) {
    //         filtered = filtered.filter(x => !x.isVoid);
    //     }

    //     return filtered;

    // };
    // const onVoidChanged = (e) => {
    //     const id = parseInt(e.target.value);
    //     setProcessingVoid(id);
    // };

    // const onVoidSubmit = async () => {

    //     //console.log("Toggling void...");
    //     await sleep(2000);
    //     toggleVoid(processingVoid);
    //     setProcessingVoid(-1);
    //     setRefresh(true);
    // };
    // const onShowVoidChange = (e) => {
    //     const newValue = e.target.checked;
    //     setShowVoid(newValue);
    // };



    const _HistoryTable = ({history = []}) =>
        <Table striped bordered hover responsive >
            <thead>
                <tr>
                    {/* <th className="text-center">Void Check Box</th> */}
                    <th>Status</th>
                    <th>Reason for Change</th>
                    <th>Begin Date</th>
                    <th>End Date</th>
                    <th>Date Changed</th>
                    <th>Changed By</th>
                    <th>Added By</th>
                </tr>

            </thead>
            <tbody>
                {history.map((item,index) => (
                    <tr key={index}>
                        {
                            processingVoid == item.applicationStatusHistoryId ? <td colSpan={7}><DotLoader /></td> :
                                <>
                                    <td style={{whiteSpace: 'pre-line'}}>{`${item.status}\n\n${item.additionalstatus}`}</td>
                                    <td className="text-wrap" style={{ maxWidth: '200px', maxHeight: '200px' }}>{item.reason}</td>
                                    <td>{item.begin}</td>
                                    <td>{item.end && item.end}</td>
                                    <td>{item.changeddate}</td>
                                    <td>{item.changedby}</td>
                                    <td>{item.createdby}</td>
                                </>
                        }

                    </tr>
                ))}
            </tbody>
        </Table>;

    return (
        <Row>
            <Col xs={12}>
                <div className="clientCard mb-3">
                    <div className="clientCardInner">
                        <h4 className="text-center">Kentucky Transition Client History</h4>
                        {/* <_HistoryTable /> */}
                        {isLoading ? <LoadingSpinner text={'Fetching History...'} /> : <_HistoryTable history={data}/>}
                    </div>
                </div>
            </Col>
        </Row>
    );
};





export default ClientApplicationHistory;